import instance from '../../api';
import { ISearchUsersParams, IStaffListReq, IUsersForSync } from './interface';

export const getStaff = () => {
  return instance()
    .post('/staff/list', {})
    .then((response) => response.data);
};

export const getStaffPagedList = (data: IStaffListReq) => {
  return instance()
    .post('/staff/pagedList', data)
    .then((response) => response.data);
};

export const saveStaff = (positionId: number, userId: string) => {
  return instance()
    .post('/staff/save', {
      positionId: positionId,
      userId: userId,
    })
    .then((response) => response.data);
};

export const updateStaff = (positionId: number, userId: string, executor: boolean) => {
  return instance()
    .post('/staff/update', {
      positionId: positionId,
      userId: userId,
      executor: executor,
    })
    .then((response) => response.data);
};

export const deleteStaff = (positionId: number, userId: string) => {
  return instance()
    .post('/staff/delete', {
      positionId: positionId,
      userId: userId,
    })
    .then((response) => response.data);
};

export const getPositions = () => {
  return instance()
    .post('/dictionary/adminPositions', {})
    .then((response) => response.data);
};

export const getUsersForSync = (values: ISearchUsersParams) => {
  return instance()
    .post<IUsersForSync[]>('/octell/listUsers', values)
    .then((response) => response.data);
};

export const mapOktellUserToKeycloak = (oktellId: string, userId: string) => {
  return instance()
    .post('/octell/mapUser', { oktellId, userId })
    .then((response) => response.data);
};

export const deleteUserMapping = (oktellId: string) => {
  return instance()
    .post('/octell/deleteUserMapping', { oktellId })
    .then((response) => response.data);
};

export const syncOktellUsers = () => {
  return instance()
    .post('/sync/syncOktellUsers')
    .then((response) => response.data);
};
